import { Suspense } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { ProceedButtonAsync } from './ProceedButtonAsync';
import { ProceedButtonSkeleton } from './ProceedButtonSkeleton';
import type { ProceedButtonStreamProps } from './types';

/**
 * Component for streaming proceed button display
 *
 * Two-layer error handling:
 * - ErrorBoundary: catches thrown errors from ProceedButtonAsync (logs + shows skeleton)
 * - Suspense: shows skeleton during streaming while async data loads
 *
 * Both layers use the same skeleton fallback for a consistent loading UI.
 *
 * Pattern: ErrorBoundary > Suspense > AsyncComponent
 */
export function ProceedButtonStream(props: ProceedButtonStreamProps) {
  return (
    <ErrorBoundary fallback={<ProceedButtonSkeleton />}>
      <Suspense fallback={<ProceedButtonSkeleton />}>
        <ProceedButtonAsync {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
